import $ from 'jquery';

var LINEARVIEW = {
    root_path:"",
    is_portal:false,
    getString :null,
    init : function($scope){
        $scope.str_device = LINEARVIEW.getString("test_result_header_device");
        $scope.str_router = LINEARVIEW.getString("main_wifi_router_short");
        $scope.str_internet = LINEARVIEW.getString("test_result_header_internet");
        $scope.str_fixed_line = LINEARVIEW.getString("main_fixed_line_short");
        $scope.str_wifi = LINEARVIEW.getString("main_wifi_network_short");

        $scope.dev_img = LINEARVIEW.root_path +"h2g-linear-view/images/home_device.svg";
        $scope.router_img = LINEARVIEW.root_path +"h2g-linear-view/images/home_router.svg";
        $scope.int_img = LINEARVIEW.root_path +"h2g-linear-view/images/home_internet.svg";
        $scope.close_icon = LINEARVIEW.root_path +"ic_close_btn.png";
        $scope.is_portal = LINEARVIEW.is_portal;
    },
    controller : function linear_view_ctrl($scope, $rootScope,cb) {
        var ht = $(".linear_view_orbit_circle").height();
        $(".linear_view_orbit").css('width',ht+'px').css('height',ht+'px');
        $(".lv_img").css('width',(ht/2)+'px');
        $scope.onClickLinearViewOrbit = function(id){
            if(cb) cb(null,{id:id});
        };
        $scope.on_close_notification_layer = function(){
            $("#lv_notifications").hide();
        };
    },
    remove_arrows : function(){
        $(".lv_help_dialog").hide();
        $(".lv_help_dialog").empty();
        ["internet","router","device","fixed_line","wifi"].forEach(function(dId){
            if($("#lv_"+dId).hasClass(dId+"_arrow")) $("#lv_"+dId).removeClass(dId+"_arrow");
        });
    }
};
export default LINEARVIEW;
